
import * as React from "react"

import { cn } from "@/lib/utils"

interface InputProps extends React.ComponentPropsWithoutRef<"input"> {
  formatPhone?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, formatPhone = false, onChange, ...props }, ref) => {
    // Create a copy of props to avoid modifying the original object
    const safeProps = {...props};
    
    // Convert boolean values to strings to avoid type errors
    if (typeof safeProps.value === "boolean") {
      safeProps.value = String(safeProps.value);
    }

    // Custom change handler for phone formatting
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (formatPhone) {
        // Remove all non-digit characters
        let value = e.target.value.replace(/\D/g, '');
        
        // Limit to 10 digits
        value = value.slice(0, 10);
        
        // Format as XXX-XXX-XXXX
        if (value.length > 0) {
          if (value.length <= 3) {
            value = value;
          } else if (value.length <= 6) {
            value = `${value.slice(0, 3)}-${value.slice(3)}`;
          } else {
            value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
          }
        }
        
        // Update the input value
        e.target.value = value;
      }
      
      // Call the original onChange handler if it exists
      if (onChange) {
        onChange(e);
      }
    };
    
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        onChange={formatPhone ? handleChange : onChange}
        {...safeProps}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
